import http from "../../http";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import {
  Question,
  Questionnaire
} from "../../../../domain/entities/exercise/question";
import { QuestionInterface } from "./question_interface";
import { ListResponse } from "../../../../domain/entities/shop/product/listResponse";
import { Answer } from "../../../../domain/entities/exercise/choice";
import { Exercise } from "../../../../domain/entities/exercise/exercise";

class _QuestionRepository implements QuestionInterface {
  list(
    questionnaireID: number,
    page?: number
  ): Promise<ListResponse<Question[]>> {
    return wrapErrorHandler<ListResponse<Question[]>>(async () => {
      const response = await http.get(
        `/api/decola/exercise/questionnaire/${questionnaireID}`,
        {
          params: {
            page: page
          }
        }
      );
      return response.data;
    });
  }

  async submit(
    questionnaireID: number,
    questionID: number,
    alternativeID: number
  ): Promise<Answer> {
    return wrapErrorHandler<Answer>(async () => {
      const response = await http.post(
        `/api/decola/exercise/questionnaire/${questionnaireID}/question/${questionID}/alternative/${alternativeID}`
      );
      return response.data;
    });
  }

  async getQuestionnaire(questionnaireID: number): Promise<Questionnaire> {
    return wrapErrorHandler<Questionnaire>(async () => {
      const response = await http.get(
        `/api/decola/exercise/questionnaire/cover/${questionnaireID}`
      );
      return response.data;
    });
  }

  async finishQuestionnaire(questionnaireID: number): Promise<void> {
    return wrapErrorHandler<Promise<void>>(async () => {
      const response = await http.post(
        `/api/decola/exercise/questionnaire/${questionnaireID}/finish`
      );
      return response.data;
    });
  }

  listResponseQuestions(
    trainingID: number,
    contentID: number,
    questionnaireID: number
  ): Promise<Exercise> {
    return wrapErrorHandler<Exercise>(async () => {
      const response = await http.get(
        `/api/decola/courses/${trainingID}/contents/${contentID}/questionnaires/${questionnaireID}/responses`
      );
      return response.data;
    });
  }
}

export const interfaceQuestionRepository: QuestionInterface = new _QuestionRepository();
